import {useState, useEffect} from 'react';
import { DanceItem } from './DanceItem';
import MultiLineComponent from './MultiLineComponent';
import { useNavigate, useParams } from 'react-router-dom';




type danceItemCompProps = {
    danceItem:DanceItem,
    isSelected:boolean,
    onClick:(id:number, startTimeInSeconds:number)=>void
}

const DanceItemComp = (props:danceItemCompProps) => {

    //const [year, setYear] = useState('');

    useEffect(() => {
        // Run! Like go get some data from an API.
        //setYear(`${new Date().getFullYear()}`);
      }, []);

      const navigate = useNavigate();

    const handleClick = ()=> {
        props.onClick(props.danceItem.id, props.danceItem.startTimeInSeconds);
    }

    const handleDoubleClick = ()=> {
        navigate(`/Edit/${props.danceItem.id}`);
    }
    

    let tailwindClasses = "border-2 border-solid text-xs";
    if (props.isSelected) {
        tailwindClasses += " border-red-400";
    }

    //<textarea className="text-xs border-black" rows={5} cols={45} value={props.danceItem.description} readOnly={true}></textarea >
    
    return(
        <div className={tailwindClasses}  onClick={handleClick} onDoubleClick={handleDoubleClick}>
            <div className=''>
                <div>{props.danceItem.source}</div>
                <div className='flex flex-wrap gap-2'>
                  <div className='font-bold'>{props.danceItem.name}</div><div className='text-[7px]'>{props.danceItem.date.toString().substring(0,10)}</div>
                </div>
                <MultiLineComponent text = {props.danceItem.description} uniqueKey=''/>
            </div>
            
        </div>
    );
}

export default DanceItemComp;